import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { connect } from 'react-redux';
import { fetchOrdenesEnVerde, setFiltroOrdenes } from '../../../actions/ordenesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import OrdenProvListItem from './OrdenProvListItem';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import BigSpinner from "../../General/BigSpinner";
import FiltroOrdenes from '../FiltroOrdenesProveedores';
import BtnToggleFilter from '../../General/Filter/BtnToggleFilter';
const fechaFiltro = filtroMedioMes();


class ListOrdenesProv extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            request: {
                idUsuario: "",
                pageSize: 10,
                page: 1,
                documento: "",
                idOrden: "",
                idEstado: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                fechaModific: "",
                skuMarket: "",
                idTipoPlataforma: null,
                idOrdenDesde: null,
                idOrdenHasta: null
            },
            showFilter: this.props.filtro?.showFilter ?? false,
        };
    }

    componentDidMount() {

        let estadoInicioFiltraPor_Moderador = {
            ...this.state.request,
            idUsuario: ""
        };

        let request = this.props.filtro;

        const { userType } = this.props;

        if (this.props.emptyFiltro.ordenes) {
            if (userType.isAdminMod || userType.isSoloLectura) {
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador })
                this.props.fetchOrdenesEnVerde(estadoInicioFiltraPor_Moderador);
            } else {
                if (userType.isProveedor) {

                    this.state.request.codProv = this.props.codProv;
                }
                this.props.setFiltroOrdenes(this.state.request);
                this.props.fetchOrdenesEnVerde(this.state.request);
            }
        } else {
            request.page = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
            this.props.fetchOrdenesEnVerde(request);
        }

        if (userType.isAdminMod || userType.isSoloLectura) {
            this.props.fetchSellersFilter(null);
        }
    }

    handleShowFilter = (value) => {
        this.setState({ showFilter: value });
        this.props.setFiltroOrdenes({ ...this.props.filtro, showFilter: value });
    }

    setModerador = () => {
        const { userType } = this.props;
        this.props.setRoleModerador(!userType.isAdminMod);
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        let params = {};

        const { userType } = this.props;
        if (userType.isAdminMod || userType.isSoloLectura) {
            params = {
                ...this.state.request,
                page: selectedPage
            }
        } else {
            params = {
                ...this.state.request,
                idUsuario: "",
                page: selectedPage
            }
        }

        this.setState({
            request: params,
            page: selectedPage
        });

        this.updateRequest(params);
    };

    updateRequest = (request) => {

        let params = {
            ...this.state,
            request: request
        }

        const { userType } = this.props;
        if (!userType.isAdminMod && !userType.isSoloLectura) {
            request.idUsuario = "";
            if (userType.isProveedor) {
                request.codProv = this.props.codProv;
            }
            params = {
                ...this.state,
                request: request
            }
        }

        this.setState({ request: params.request, currentPage: params.request.page }, () => {
            this.props.setFiltroOrdenes(this.state.request);
            this.props.fetchOrdenesEnVerde(this.state.request);
        });
    }


    render() {
        const { ordenes, userType } = this.props;
        let elementos = ordenes.elementos === undefined ? [] : ordenes.elementos;

        return (
            <div className="container">


                <>
                    <div className="button-group col-12 text-end">
                        <BtnToggleFilter
                            show={this.state.showFilter}
                            handleShow={() => this.handleShowFilter(!this.state.showFilter)}
                        />
                    </div>

                    <div hidden={!this.state.showFilter}>
                        <FiltroOrdenes
                            filtro={this.props.filtro}
                            updateRequest={this.updateRequest}
                            tipoUsuario={userType}
                            allowSearchBySeller={false}
                        />
                    </div>
                </>


                <div hidden={!this.props.loadingOrdenes}>
                    <BigSpinner />
                </div>

                <div hidden={elementos.length > 0 || this.props.loadingOrdenes}>
                    <h5 className="d-flex justify-content-center my-4">
                        NO SE ENCONTRARON RESULTADOS
                    </h5>
                </div>


                <div className="d-none d-md-flex row px-3 py-3 text-uppercase text-secondary small fw-bold border-bottom mb-2">
                    <div className="col-lg-1 col-md-2">Fecha / ID</div>
                    <div className="col-md-2 text-center">Cliente</div>
                    <div className="col-lg-5 col-md-6">Productos</div>
                    <div className="col-md-2 text-center">Monto</div>
                    <div className="col-md-2 text-center">Acciones</div>
                </div>

                <div className="" hidden={this.props.loadingOrdenes}>
                    {elementos.length > 0 ? elementos.map((orden, index) => {

                        if (!userType.isAdminMod) {
                            return (
                                <div key={index}>
                                    <OrdenProvListItem
                                        mailCliente={""}
                                        idOrden={orden.idOrden}
                                        fecha={orden.fecha}
                                        cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                        documento={orden.cliente.documento}
                                        tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                        montoVenta={orden.montoVenta}
                                        productos={orden.productos}
                                        anulacionMegatone={orden.anulacionMegatone}
                                        obleaDescargada={orden.obleaDescargada}
                                        comprobante={orden.comprobante}
                                        userId={this.props.userId}
                                    />
                                </div>
                            )
                        }
                        else if (userType.isAdminMod || userType.isSoloLectura) {
                            return (
                                <a key={index}>
                                    <OrdenProvListItem
                                        mailCliente={orden.cliente.email}
                                        idOrden={orden.idOrden}
                                        key={index}
                                        fecha={orden.fecha}
                                        cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                        documento={orden.cliente.documento}
                                        tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                        montoVenta={orden.montoVenta}
                                        productos={orden.productos}
                                        dniIdBocaSeller={orden.idVendedorBoca}
                                        plataformaCodigo={orden.plataforma.codigo}
                                        anulacionMegatone={orden.anulacionMegatone}
                                        obleaDescargada={orden.obleaDescargada}
                                        comprobante={orden.comprobante}
                                        userId={this.props.userId}
                                    />
                                </a>
                            )
                        }
                    }) : null
                    }
                </div>

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.ordenes.cantidadTotal / this.state.request.pageSize}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={this.state.request.pageSize}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={
                            this.props.filtro?.numeroPagina ?
                                this.props.filtro.numeroPagina - 1 : 0
                        }
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    ordenes: state.ordenes.ordenesEnVerde,
    filtro: state.ordenes.filtro,
    filtro: state.ordenes.filtro,
    userId: state.general.userId,
    codProv: state.general.codProv
});

export default connect(mapStateToProps, {
    fetchOrdenesEnVerde,
    limpiarFiltros,
    setFiltroOrdenes,
    fetchSellersFilter
})(ListOrdenesProv);